/**
 * @flow
 * @relayHash b6eacebba4f127c7d3234b30e0160a5a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteShipmentInput = {|
  id: string
|};
export type DeleteShipmentMutationVariables = {|
  input: DeleteShipmentInput
|};
export type DeleteShipmentMutationResponse = {|
  +deleteShipment: {|
    +deletedId: string
  |}
|};
export type DeleteShipmentMutation = {|
  variables: DeleteShipmentMutationVariables,
  response: DeleteShipmentMutationResponse,
|};
*/


/*
mutation DeleteShipmentMutation(
  $input: DeleteShipmentInput!
) {
  deleteShipment(input: $input) {
    deletedId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteShipmentInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteShipment",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteShipmentPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteShipmentMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteShipmentMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteShipmentMutation",
    "id": null,
    "text": "mutation DeleteShipmentMutation(\n  $input: DeleteShipmentInput!\n) {\n  deleteShipment(input: $input) {\n    deletedId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5254917f1d5e3f1e7b59ba3a0721e31a';
module.exports = node;
